module.exports = __webpack_public_path__ + "static/img/smiling-woman-wearing-black-sweater-1587009.5e889b2e.jpg";